import { Component, Input, OnInit } from '@angular/core';
import { OOVenue } from '../../models/oo-venue';

@Component({
	selector: 'app-venue-header',
	templateUrl: './venue-header.component.html',
	styleUrls: ['./venue-header.component.scss'],
})
export class VenueHeaderComponent implements OnInit {
	@Input() ooVenue: OOVenue;
	@Input() loading: boolean;
	@Input() error: string;
	@Input() message: string;

	constructor() {}

	ngOnInit(): void {
		console.log(this.ooVenue);
	}
}
